<!-- Render accordingly to column type -->
<div
  [ngSwitch]="expandRowColumnDef.column.type"
  class="gd-list-table-detail-column"
  fxLayout="row"
  (click)="expandCollapse()">

  <!-- expand / collapse indication -->
  <mat-icon>{{expandRowColumnDef && detailsRow?.column === expandRowColumnDef ? 'expand_less' : 'expand_more' }}</mat-icon>

  <!-- Changes -->
  <div
    *ngSwitchCase="V2ColumnExpandRowType.CHANGES"
    fxFlex>
    {{ 'LNG_COMMON_LABEL_NO_OF_CHANGES' | translate:dataNoOfChanges }}
  </div>

</div>
